import { useCallback } from 'react';

interface IParams {
  component: React.ReactNode;
  position: number;
  totalSize: number;
}

export const useBannerRenderer = ({ component, position, totalSize }: IParams) => {
  const renderBanner = useCallback(
    (currentIndex?: number) => {
      // Рендерим баннер на указанной позиции или в конце списка
      if (currentIndex === position - 1 || (position > totalSize && currentIndex === undefined)) {
        return component;
      }

      return null;
    },
    [component, position, totalSize],
  );

  return renderBanner;
};
